export const sixCharAlphanumeric = /^[A-Za-z0-9]{6}$/;
export const thirteenDigitNumeric = /^\d{13}$/;
export const ticketNumberPattern = /^279\d{10}$/;
export function sanitizeConfirmationCode(value: string): string {
  return value.replaceAll(/\W/g, "");
}
export function isTicketNumber(value: string): boolean {
  return ticketNumberPattern.test(sanitizeConfirmationCode(value));
}
